export default "__VITE_ASSET__DO2Svcm8__"